// extracted by mini-css-extract-plugin
export default {"subheading":"styles_subheading__vAAbN","checkbox":"styles_checkbox__5DzQd","statusField":"styles_statusField__kg7Br","statusLabel":"styles_statusLabel__hcpol"};